import { Pipe, PipeTransform } from "@angular/core";
import { formatDistance } from "date-fns";

@Pipe({
  name: "timeAgo"
})
export class TimeAgoPipe implements PipeTransform {

  transform(value: Date, ...args: any[]): string {
    if (!value) { return ""; }

    return formatDistance(value, new Date(), { addSuffix: true }).replace(/^about\s+/i, "");
  }

}
